import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    yearlyPlanForbidden: (selectedLocation: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message when yearly plan is forbidden in selected location. Use {selectedLocation} for the location name */
            yearlyPlanForbidden: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (selectedLocation: string): string => __intl__.intl().formatMessage({ id: "BillingStripeAddressElement.yearlyPlanForbidden?c=12fpchxr4c6k8", defaultMessage: "The annual plan you''re subscribed to is not available in {selectedLocation}. To change your billing address to {selectedLocation}, please switch to a monthly plan. For assistance, contact customer support." }, { selectedLocation: selectedLocation }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
